import { component } from 'picoapp';
import Swiper, { Scrollbar } from 'swiper';

export default component(async (node) => {
  const slider = node.querySelector<HTMLElement>('[data-slider]');
  const progressBar = node.querySelector<HTMLElement>('[data-progress-bar]');

  // eslint-disable-next-line no-new
  new Swiper(slider, {
    modules: [Scrollbar],
    scrollbar: {
      el: progressBar,
      dragClass: 'product-slider__drag',
    },
    loop: true,
    centeredSlides: true,
    slidesPerView: 2.2,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
    },
  })
});
